import { PMI_DEVICE_PAGE_HELP_ENTRIES } from './pageHelpManifest.pmiDevices';

export const PAGE_HELP_MANIFEST = Object.freeze([
  {
    routePrefix: '/dashboard',
    title: 'Dashboard',
    description: 'Обобщена статистика за устройства, регистрация и регионално разпределение.',
    points: [
      'Картите горе са моментен snapshot за общо, локирани и активни устройства.',
      'Графиките показват тренд по дати и разпределение по региони/TAL.',
      'Данните се обновяват периодично автоматично.',
    ],
    sections: [
      {
        title: 'Как да четеш екрана',
        points: [
          'Това е summary view, не device-level таблица. Използвай го за бърза картина, после drill-down към device страниците.',
          'Всички стойности идват от dashboard summary endpoint и са snapshot към часа на последния refresh.',
        ],
      },
    ],
    definitions: [
      {
        term: 'Total Devices',
        description: 'Общият брой устройства, включени в backend summary-а за този dashboard.',
      },
      {
        term: 'Located',
        description: 'Устройства с налична локационна/координатна информация, която може да се използва в карти и гео групиране.',
      },
      {
        term: 'Online (24h)',
        description: 'Устройства, които са засечени в activity window-а. Числото в скоби идва от activeWindowHours.',
      },
      {
        term: 'Registration Status',
        description: 'Съотношение между registered и not registered устройства в текущия snapshot.',
      },
      {
        term: 'Devices by Region / Devices by TAL',
        description: 'Разпределение по регион и TAL само за устройства с linked PMI location в текущия snapshot, не за целия fleet.',
      },
      {
        term: 'Active linked locations / Needs location work',
        description: 'Active linked locations брои само устройства върху активни linked locations. Needs location work събира inactive locations, unknown location status и unlinked devices.',
      },
      {
        term: 'Registration Status by Date',
        description: 'Исторически trend по дати за registered и not registered устройства.',
      },
    ],
  },
  {
    routePrefix: '/dashboard-sofia-edition',
    title: 'Sofia Dashboard',
    description: 'Widget dashboard за Sofia estate с drag-and-drop layout и бързо включване/изключване на cards.',
    points: [
      'Чекбоксовете горе контролират кои widgets са видими в layout-а.',
      'Drag-and-drop мести видим widget между зоните според правилата за size/kind.',
      'Layout storage пази подредбата в текущия браузър, не глобално за всички потребители.',
    ],
    sections: [
      {
        title: 'Как да ползваш страницата',
        points: [
          'Ползвай чекбоксовете за show/hide и после drag-and-drop за подредба по зони.',
          'Ако drop е невалиден, ще видиш причина според правилата на зоната.',
          'Open wallboard отваря live версиjaта за екрана на стената в отделен tab.',
        ],
      },
      {
        title: 'Какво означават времевите прозорци',
        points: [
          'Active window е operational window за activity и по подразбиране е 24h.',
          'Live window е по-къс прозорец за текущ footprint и по подразбиране е 30 min.',
          'Snapshot timestamp показва кога е генериран последният backend summary, който гледаш.',
        ],
      },
    ],
    definitions: [
      {
        term: 'Snapshot',
        description: 'Времето на последния summary refresh от backend-а за Sofia dashboard-а.',
      },
      {
        term: 'Widget count',
        description: 'Броят widgets, които в момента са включени и видими в текущия browser layout.',
      },
      {
        term: 'Active devices',
        description: 'Устройства, seen inside the last active window. В UI това е Active in Xh.',
      },
      {
        term: 'Inactive devices',
        description: 'Устройства извън текущия activity window, тоест без recent activity в този период.',
      },
      {
        term: 'Live now',
        description: 'Устройства, засечени в live window-а. Това е по-строг и по-кратък operational footprint.',
      },
      {
        term: 'Registered devices',
        description: 'Устройства, които имат PMI registration match в текущия summary snapshot.',
      },
      {
        term: 'Activity rate',
        description: 'Процент active devices спрямо total estate в текущия snapshot.',
      },
      {
        term: 'Registration rate',
        description: 'Процент устройства с PMI registration match спрямо total devices.',
      },
      {
        term: 'Top regions / Top cities / TAL concentration',
        description: 'Ранкинги по текущия snapshot за устройства с linked location/mapped estate, не за целия fleet total.',
      },
    ],
  },
  {
    routePrefix: '/dashboard-sofia-edition-live',
    title: 'Sofia Wallboard',
    description: 'Пълноекранен live оперативен изглед за Sofia estate, оптимизиран за wall screen.',
    points: [
      'Това е read-only view без widget builder controls.',
      'Основният фокус е текущото operational health състояние и картата с live footprint.',
      'Използвай го за стенен екран, не за редакция на layout-а.',
    ],
    sections: [
      {
        title: 'Как да четеш wallboard-а',
        points: [
          'Wall clock е локалният часовник на самата стена/браузър сесия.',
          'Last refresh показва последния backend snapshot, а не последния frame render.',
          'Health card комбинира active rate, registration rate и total devices за бърз operational read.',
        ],
      },
    ],
    definitions: [
      {
        term: 'Wall clock',
        description: 'Текущата локална дата и час на браузъра, който показва wallboard-а.',
      },
      {
        term: 'Last refresh',
        description: 'Кога backend snapshot-ът е обновен за последно.',
      },
      {
        term: 'Live / Active / Inactive / Registered',
        description: 'Ключовите KPI counts за текущия snapshot на Sofia estate.',
      },
      {
        term: 'Active rate',
        description: 'Процент active devices спрямо total devices.',
      },
      {
        term: 'Registration',
        description: 'Registration rate, тоест процентът устройства с PMI registration match.',
      },
      {
        term: 'Mapped devices',
        description: 'Устройства с координати, които могат да бъдат показани върху картата.',
      },
    ],
  },
  {
    routePrefix: '/weekly-report',
    title: 'Weekly Report',
    description: 'Подготовка на седмичен клиентски отчет по избран TAL.',
    points: [
      'Изборът горе работи по полето TAL от PMI devices.',
      'Device health използва 24h activity window, а Proof of Play е current live snapshot.',
      'Страницата е подготвена като база за бъдещ email template.',
    ],
    definitions: [
      {
        term: 'Window',
        description: 'Използваният времеви прозорец за част от метриките, напр. live proof-of-play window.',
      },
      {
        term: 'IsActive = 0',
        description: 'Устройства, които в source данните са маркирани като неактивни и затова се следят отделно в weekly report.',
      },
      {
        term: 'Seen in activity window',
        description: 'Процент или брой устройства, които имат activity вътре в определения operational window.',
      },
      {
        term: 'Proof of Play',
        description: 'Snapshot за съдържание/plays, базиран на now-playing и исторически proof-of-play данни.',
      },
    ],
  },
  {
    routePrefix: '/inactive-escalation',
    title: 'Inactive SLA',
    description: 'Admin-only страница за policy rules и 24h preview на inactive devices escalation flow.',
    points: [
      'Policy панелът показва потвърдените business rules, recipient sources и escalation matrix.',
      'Preview панелът показва текущия 24h scope, TAL groups и email jobs без реално изпращане.',
      'Това е оперативен admin екран върху backend preview endpoint-ите, не клиентска крайна страница.',
    ],
  },
  {
    routePrefix: '/simulation-results',
    title: 'Simulation Results',
    description: 'Резултати от симулации на кампанийна логика.',
    points: [
      'Използвайте филтрите за период, кампания и статус.',
      'Таблицата показва детайлен резултат по ред.',
      'Проверявайте error/warning редовете за проблемни случаи.',
    ],
  },
  {
    routePrefix: '/simulation-Page',
    title: 'Simulation Page',
    description: 'Работна страница за пускане и преглед на симулации.',
    points: [
      'Изберете входни параметри и стартирайте симулация.',
      'След изпълнение данните се виждат в таблиците с резултати.',
      'При промяна на параметри стартирайте нов run.',
    ],
  },
  {
    routePrefix: '/contacts',
    title: 'Contacts',
    description: 'Управление и преглед на контактите в системата.',
    points: [
      'Търсете по име/имейл и филтрирайте по нужните полета.',
      'Редакциите се записват на ниво запис.',
      'Използвайте контактите за достъп и assignment потоци.',
    ],
  },
  {
    routePrefix: '/dashboardStatus',
    title: 'Stats',
    description: 'Разширени статистики за устройство и статус.',
    points: [
      'Сравнявайте online/offline и активност по времеви прозорци.',
      'Проверявайте аномалии в трендове и сривове.',
      'Използвайте в комбинация с филтрите от device страниците.',
    ],
  },
  {
    routePrefix: '/devices',
    title: 'Devices',
    description: 'Оперативна таблица за устройства (legacy view).',
    points: [
      'Филтрите горе определят набора от видими устройства.',
      'От Actions правите batch действия върху селекция.',
      'Детайлите по устройство показват техническа и локационна информация.',
    ],
  },
  ...PMI_DEVICE_PAGE_HELP_ENTRIES,
  {
    routePrefix: '/my-devices',
    title: 'My Devices',
    description: 'Персонализиран изглед на устройства за текущия потребител.',
    points: [
      'Показват се устройства според assigned/contact логика.',
      'Използвайте локалните филтри за по-бърз преглед.',
      'Детайлите и actions работят както в основните device таблици.',
    ],
  },
  {
    routePrefix: '/locations',
    title: 'Locations',
    description: 'Управление на локации и връзка към устройства.',
    points: [
      'Търсете и филтрирайте по име, град и организационни полета.',
      'Промените по локация влияят на свързаните устройства.',
      'Проверявайте коректност на TA/TAL/Region стойностите.',
    ],
  },
  {
    routePrefix: '/pmi-locations',
    title: 'PMI Locations',
    description: 'PMI location master данни и enrichment източник.',
    points: [
      'Тук са основните location полета за обогатяване.',
      'Проверявайте reevCode и ключовите mapping полета.',
      'При import първо тествайте с dry-run.',
    ],
    sections: [
      {
        title: 'Как да четеш секциите',
        points: [
          'Manual Entry е за единична корекция или ръчно добавяне на обект без да чакаш следващия Excel import.',
          'Import From Excel е batch поток и е добре първо да минава през dry-run, за да видиш какво ще бъде променено.',
          'Filters And List е оперативната справка за търсене и cleanup на location master данните.',
        ],
      },
    ],
    definitions: [
      {
        term: 'REEV CODE',
        description: 'Кодът, по който location записът може да се match-не към устройство и да се обнови linkage/обогатяване.',
      },
      {
        term: 'Dry Run',
        description: 'Проверка какво ще промени import-ът, без реално да записва данните в базата.',
      },
      {
        term: 'TA / TAL',
        description: 'Организационните полета за търговския екип, по които се правят филтри, групиране и някои dashboard разрези.',
      },
      {
        term: 'Device Linkage',
        description: 'Степента, в която location записът е свързан към устройство или може да бъде използван за автоматично link-ване.',
      },
      {
        term: 'POS Type Strategy',
        description: 'Класификационно поле за типа обект/екран, използвано в enrichment и филтриране.',
      },
    ],
  },
  {
    routePrefix: '/pmi-mapping-log',
    title: 'PMI Mapping Log',
    description: 'Сравнение между source import полетата и derived PMI mapping стойностите.',
    points: [
      'Използвайте страницата за бърза проверка как source стойностите се преобразуват след import.',
      'Trade Segment, POS Type, Manned и TAL се показват като source срещу mapped резултат.',
      'Route-ът наследява достъпа на PMI Locations, за да не изисква отделна role промяна.',
    ],
  },
  {
    routePrefix: '/ta-tal-addresses',
    title: 'TA&TAL Addresses',
    description: 'Адресни данни за TA/TAL и помощни справки.',
    points: [
      'Използвайте филтрите за регион, роля и град.',
      'След import валидирайте липсващи/дублирани записи.',
      'Тези данни се ползват в location/device обогатяване.',
    ],
  },
  {
    routePrefix: '/pmi-device-logs',
    title: 'PMI Device Logs',
    description: 'История на промени и събития по PMI устройства.',
    points: [
      'Филтрирайте по устройство, потребител и период.',
      'Използвайте логовете за одит и troubleshooting.',
      'Сравнявайте поредността на събитията по timestamp.',
    ],
  },
  {
    routePrefix: '/campaign-previews',
    title: 'Campaign Previews',
    description: 'Преглед на кампании и визуализация на съдържание.',
    points: [
      'Ползвайте търсене и филтри за бързо намиране на кампания.',
      'Видео/медия preview може да се autoplay/loop според конфигурацията.',
      'Проверете assignment детайли преди публикуване.',
    ],
    sections: [
      {
        title: 'Как да ползваш изгледите',
        points: [
          'Timeline tab е за period planning и бързо засичане на overlap-и между кампании.',
          'Cards tab е за визуален преглед на медията, сегментацията и validity диапазона на всяка кампания.',
          'Клик върху кампания отваря модерния editor, където можеш да провериш schedule, files и covered devices.',
        ],
      },
    ],
    definitions: [
      {
        term: 'Timeline',
        description: 'Периоден изглед, който подрежда кампаниите по start/end date и показва overlap-и във времето.',
      },
      {
        term: 'Cards',
        description: 'Визуален grid изглед с thumbnail/media preview и основните targeting параметри на кампанията.',
      },
      {
        term: 'Segment',
        description: 'Търговският/бизнес сегмент, за който кампанията е таргетирана.',
      },
      {
        term: 'POS / Screen',
        description: 'Типът обект или екран, за който кампанията е валидна.',
      },
      {
        term: 'KA / Placement',
        description: 'Key account / placement ограничения, които допълнително стесняват на кои обекти може да излезе кампанията.',
      },
      {
        term: 'Covered devices',
        description: 'Устройствата, които по текущата eligibility логика попадат в обхвата на кампанията.',
      },
    ],
  },
  {
    routePrefix: '/campaignsP',
    title: 'Campaigns',
    description: 'Основна страница за управление на кампании.',
    points: [
      'Създаване, редакция и lifecycle контрол на кампаниите.',
      'Следете валидност на периоди и активен статус.',
      'Използвайте assignment свързването към устройства.',
    ],
  },
  {
    routePrefix: '/campaigns',
    title: 'Campaign',
    description: 'Campaign editor и детайлни настройки.',
    points: [
      'Редактирайте медии, таргетиране и scheduling параметри.',
      'Проверете required полета преди запис.',
      'След save валидирайте резултата в preview страницата.',
    ],
  },
  {
    routePrefix: '/manual-campaign-assignment',
    title: 'Campaign Assignments',
    description: 'Ръчно асоцииране на кампании към устройства.',
    points: [
      'Тук се показват само кампании с включено manual activation.',
      'Първо изберете устройство, после кампания, за да видите текущите ръчни връзки преди assign.',
      'Десният панел показва на кои устройства е закачена избраната кампания и позволява individual unassign.',
    ],
    sections: [
      {
        title: 'Как работи логиката',
        points: [
          'Manual assignment не замества normal campaign logic глобално. Той добавя само конкретно assign-натите manual campaigns към normal playlist-а.',
          'Тази страница е за изключения и device-specific контрол, не за масово таргетиране на кампании.',
          'Преди assign е добре да провериш дали кампанията вече не покрива устройството по normal targeting логика.',
        ],
      },
    ],
    definitions: [
      {
        term: 'Manual activation',
        description: 'Флаг по кампания, който позволява тя да бъде ръчно assign-ната към конкретни устройства.',
      },
      {
        term: 'Assigned devices',
        description: 'Устройствата, към които избраната manual campaign е вързана ръчно.',
      },
      {
        term: 'Current device assignments',
        description: 'Manual campaign връзките за избраното устройство в момента.',
      },
      {
        term: 'Append behavior',
        description: 'Manual campaign-ите се добавят към normal playlist-а само ако са конкретно assign-нати към устройството.',
      },
    ],
  },
  {
    routePrefix: '/campaign-device-logs',
    title: 'Campaign Assignment Logs (Legacy)',
    description: 'Legacy изглед за assign/unassign действия към устройства.',
    points: [
      'Този екран е за assignment история, не за field-level промени по кампания.',
      'За редакции по кампания използвайте отделната страница Campaign Change Logs.',
      'При нужда от одит на назначавания/отписвания може да остане като справка.',
    ],
    sections: [
      {
        title: 'Как да четеш екрана',
        points: [
          'Campaign workspace показва кои устройства са вързани към избраната manual campaign.',
          'Device workspace показва обратната гледна точка: кои manual campaigns са вързани към избраното устройство.',
          'Action trail е одит секцията за assign/unassign историята и вече може да се филтрира по период.',
        ],
      },
    ],
    definitions: [
      {
        term: 'Period from / Period to',
        description: 'Ограничава history и action trail секциите до избрания времеви диапазон.',
      },
      {
        term: 'Campaign workspace',
        description: 'Панелът, в който гледаш current manual links по избрана кампания.',
      },
      {
        term: 'Device workspace',
        description: 'Панелът, в който гледаш current manual links по избрано устройство.',
      },
      {
        term: 'Action trail',
        description: 'Историята на assign/unassign действията, групирана по години и месеци.',
      },
    ],
  },
  {
    routePrefix: '/campaign-change-logs',
    title: 'Campaign Change Logs',
    description: 'Отделна страница за одит на редакции по кампании.',
    points: [
      'Показва кой, кога и кои полета е променил по кампания.',
      'Филтрирайте по редактор и ключови думи за бърз анализ.',
      'Използвайте при troubleshooting и release проверка.',
    ],
  },
  {
    routePrefix: '/campaign-edit-logs',
    title: 'Campaign Change Logs',
    description: 'Legacy route към страницата за одит на редакции по кампании.',
    points: [
      'Показва кой, кога и кои полета е променил по кампания.',
      'Филтрирайте по редактор и ключови думи за бърз анализ.',
      'Използвайте при troubleshooting и release проверка.',
    ],
  },
  {
    routePrefix: '/upload-content',
    title: 'Upload Content',
    description: 'Качване на ново съдържание и обработка.',
    points: [
      'Качете файлове и следете upload/status индикаторите.',
      'Проверете валидни формати и размери.',
      'След качване съдържанието е достъпно в Files.',
    ],
  },
  {
    routePrefix: '/list-files',
    title: 'Files',
    description: 'Библиотека с налични медийни файлове.',
    points: [
      'Търсете и филтрирайте по име, тип и валидност.',
      'Проверявайте thumbnail/preview за визуална валидация.',
      'Използвайте файловете в кампании и плейлисти.',
    ],
  },
  {
    routePrefix: '/imports',
    title: 'Imports',
    description: 'История и управление на import процеси.',
    points: [
      'Следете статус, грешки и резултат от всеки import.',
      'Проверявайте броя обработени/пропуснати редове.',
      'При проблем прегледайте детайлите и повторете процеса.',
    ],
  },
  {
    routePrefix: '/import',
    title: 'Import File',
    description: 'Ръчен import на excel/csv данни.',
    points: [
      'Изберете правилен файл и коректен sheet.',
      'Препоръчително: first dry-run, после commit import.',
      'След import направете spot-check в целевата страница.',
    ],
  },
  {
    routePrefix: '/categories',
    title: 'Categories',
    description: 'Категории за съдържание и класификация.',
    points: [
      'Създавайте и редактирайте категории за по-добра организация.',
      'Използвайте consistent naming, за да няма дублиране.',
      'Проверете свързаните schedule правила при промени.',
    ],
  },
  {
    routePrefix: '/schedule',
    title: 'Categories Schedule',
    description: 'Графици и правила за категории.',
    points: [
      'Настройте часови интервали и категории по сегменти.',
      'След save валидирайте дали конфликтите са отстранени.',
      'Тествайте ефекта през preview/оперативните таблици.',
    ],
    sections: [
      {
        title: 'Как да мислиш за schedule-а',
        points: [
          'Това е category-level availability слой. Той задава кога дадена категория може да бъде използвана по сегмент.',
          'Един ден може да има повече от един time slot, но slot-овете не трябва да се застъпват.',
          'Този екран не е директен playlist preview, а конфигурация, която после влияе на eligibility логиката.',
        ],
      },
    ],
    definitions: [
      {
        term: 'Segment',
        description: 'Бизнес/търговският сегмент, за който schedule правилото е валидно.',
      },
      {
        term: 'Slots',
        description: 'Часовите интервали вътре в деня, в които категорията е разрешена.',
      },
      {
        term: 'Sync',
        description: 'Записване на текущата schedule конфигурация към backend-а за избраната категория/сегмент.',
      },
      {
        term: 'Conflict',
        description: 'Невалиден или застъпващ се time slot, който трябва да бъде коригиран преди save.',
      },
    ],
  },
  {
    routePrefix: '/file-edit-logs',
    title: 'File Edit Logs',
    description: 'Одит лог за редакции по файлове и metadata.',
    points: [
      'Показва промени по file metadata, categories и ръчни update-и.',
      'Филтрирайте по файл, поле или редактор.',
      'Полезно за проследяване на проблеми с content setup.',
    ],
  },
  {
    routePrefix: '/proof-of-play',
    title: 'Proof of Play',
    description: 'Live агрегиране по съдържание от now-playing събития.',
    points: [
      'Таблицата показва колко пъти е play-нато всяко съдържание.',
      'Детайлите показват на кои устройства е възпроизвеждано.',
      'Debug секцията е за диагностика на SSE потока.',
    ],
    sections: [
      {
        title: 'Как работи екранът',
        points: [
          'Първо се зарежда persisted baseline history, след което live SSE events се наслагват върху нея.',
          'Content history + live е работната таблица за анализ; Bulgaria map е визуален гео изглед на същия поток.',
        ],
      },
    ],
    definitions: [
      {
        term: 'SSE',
        description: 'Статусът на live Server-Sent Events връзката за now-playing потока.',
      },
      {
        term: 'Source',
        description: 'Източникът на историческите proof-of-play данни, които са заредени като baseline.',
      },
      {
        term: 'Events since start',
        description: 'Броят live now-playing събития, добавени след зареждането на историческия baseline.',
      },
      {
        term: 'Contents',
        description: 'Броят content rows, които в момента отговарят на филтрите и наличната история.',
      },
      {
        term: 'History',
        description: 'Статус дали historical periods и persisted proof-of-play baseline са заредени успешно.',
      },
      {
        term: 'Last Event',
        description: 'Timestamp на последното получено live now-playing събитие.',
      },
    ],
  },
  {
    routePrefix: '/proof-of-play-live',
    title: 'Proof of Play Map',
    description: 'Пълноекранен map view за Proof of Play с markers и live operational status.',
    points: [
      'Това е dedicated map route, не content table workspace.',
      'Използвай го за визуално проследяване на coverage и текущи play counts по локации.',
      'Back to Proof of Play връща към пълния анализатор с tabs и таблица.',
    ],
    definitions: [
      {
        term: 'Dedicated map view',
        description: 'Read-only карта, оптимизирана за map-first наблюдение, без content table controls.',
      },
      {
        term: 'Status markers',
        description: 'Marker-ите използват live/active/inactive operational status според текущия snapshot.',
      },
      {
        term: 'Proof-of-play counts',
        description: 'Натрупаните plays за съответната локация/content в рамките на наличната history + live stream.',
      },
      {
        term: 'Location load error',
        description: 'Грешка при зареждане на location metadata, нужна за картата и marker enrichment.',
      },
    ],
  },
  {
    routePrefix: '/instructions',
    title: 'Instructions',
    description: 'Документация и помощни инструкции.',
    points: [
      'Тук публикуваме оперативни инструкции за работа.',
      'Следете последните промени по процесите.',
      'При въпроси: използвайте указания контакт/канал.',
    ],
    sections: [
      {
        title: 'Кога да ползваш тази страница',
        points: [
          'Когато ти трябва process documentation, onboarding материал или стъпки за конкретен workflow.',
          'За screen-specific help използвай иконата `i` от header-а на самата страница, не само общите инструкции.',
        ],
      },
    ],
  },
  {
    routePrefix: '/instructionsNew',
    title: 'Инструкции',
    description: 'Локализирана версия на помощната документация.',
    points: [
      'Съдържа инструкции на български език.',
      'Подходяща за onboarding и ежедневна справка.',
      'Актуализирайте при процесни промени.',
    ],
    sections: [
      {
        title: 'Практически съвет',
        points: [
          'За бързо обяснение на конкретен екран натисни `i` в самата страница и провери page help drawer-а.',
          'Тук държим по-дългите процесни инструкции, а в page help-а държим кратки дефиниции на параметрите.',
        ],
      },
    ],
  },
  {
    routePrefix: '/change-log',
    title: 'Change log',
    description: 'Хронология на промени за екип и крайни потребители.',
    points: [
      'Проверявайте последните версии и нови функционалности.',
      'Разделено е на технически и потребителски промени.',
      'Използвайте за release комуникация.',
    ],
  },
  {
    routePrefix: '/executive-summary',
    title: 'Executive Summary',
    description: 'Кратка клиентска презентация за основните направления на работа през последните седмици.',
    points: [
      'Тук държим client-facing deck с кратко executive обобщение.',
      'Използвайте `Open deck`, ако искате full-screen преглед в отделен tab.',
      'Използвайте `Print / Save PDF`, ако искате бърз файл за споделяне преди среща.',
    ],
    sections: [
      {
        title: 'Кога да ползваш тази страница',
        points: [
          'Когато ти трябва кратко business summary, а не технически changelog.',
          'Подходяща е за клиентски срещи, status review и management update.',
        ],
      },
    ],
  },
  {
    routePrefix: '/feedback-board',
    title: 'Feedback Board',
    description: 'Вътрешно място за подобрения, препоръки, бележки и discussion threads с replies.',
    points: [
      'Създайте отделен item за всяка идея или проблем, вместо да смесвате много теми в един запис.',
      'Използвайте `status`, за да стане ясно кои предложения са нови, в review, планирани, готови за testing или приключени.',
      'Под всеки item може да се води отделна дискусия с replies, за да не се губи контекстът.',
    ],
    sections: [
      {
        title: 'Как да ползваш страницата',
        points: [
          '`Improvement` и `Recommendation` са подходящи за идеи и follow-up предложения.',
          'Използвайте `Issue`, когато има конкретен operational или UX проблем.',
          'Използвайте `Note`, когато искате да запазите контекст, който после може да се превърне в задача.',
          'Използвайте `Knowledge Base`, когато темата е support въпрос, documentation gap или искане да се насочи човек към page help (`i`) и help страниците.',
        ],
      },
    ],
  },
  {
    routePrefix: '/access-control',
    title: 'Access Control',
    description: 'Управление на роли по потребители и покани за регистрация.',
    points: [
      'Може да променяте роли на текущи потребители.',
      'Може да изпращате покани с предварително зададени роли.',
      'Промените влизат в сила след нов login/token refresh.',
    ],
  },
  {
    routePrefix: '/access-audit-logs',
    title: 'Access Audit Logs',
    description: 'Одит лог за създаване/регистрация на потребители, покани, роли и права.',
    points: [
      'Показва кой е извършил action-а, кога и върху кой обект.',
      'Филтрирайте по action, entity type, user и статус за бърза проверка.',
      'Използвайте при troubleshooting на достъп и промени по security модела.',
    ],
    sections: [
      {
        title: 'Как да четеш графиките',
        points: [
          'Горният summary следва текущите top filters и може да превключва между unique users и login count.',
          'Day / Week сменя агрегацията на графиката, а stacked bar-овете показват разбивка по потребители.',
          'Exclude office филтрите са полезни, когато искаш да гледаш реално човешко ползване, а не service/admin account activity.',
        ],
      },
    ],
    definitions: [
      {
        term: 'Unique users',
        description: 'Броят различни потребители, които са имали login activity в периода.',
      },
      {
        term: 'Login count',
        description: 'Общият брой login събития, включително multiple logins от един и същи потребител.',
      },
      {
        term: 'Day / Week',
        description: 'Нивото на агрегация на графиката: по дни или по ISO седмици.',
      },
      {
        term: 'Exclude office@smartad.bg / office@omnichannel.bg',
        description: 'Премахва activity от тези service/admin акаунти при графиките и summary анализа.',
      },
      {
        term: 'Performed by',
        description: 'Потребителят, който е извършил съответното access control действие.',
      },
    ],
  },
  {
    routePrefix: '/roles-permissions',
    title: 'Roles & Permissions',
    description: 'Конфигуриране на роли, menu access и granular permissions.',
    points: [
      'Menu Access контролира кои менюта се виждат в sidebar.',
      'Page Access Matrix задава View/Edit на ниво страница.',
      'Permissions Catalog служи за пълен CRUD на permission ключове.',
    ],
  },
  {
    routePrefix: '/server-health',
    title: 'Server Health',
    description: 'Оперативен health dashboard за load, memory, disk, Mongo и proof-of-play pipeline състоянието на сървъра.',
    points: [
      'Горният summary показва последния наличен snapshot и live SSE статуса към server health stream-а.',
      'Trend chart-ът наслагва load, memory, swap, Mongo ping и Mongo connections в избрания времеви прозорец.',
      'Тази страница е за operational diagnosis, не за business KPI анализ.',
    ],
    sections: [
      {
        title: 'Как да ползваш страницата',
        points: [
          'Първо гледай current status, active alerts и последния checkedAt timestamp, за да разбереш дали има актуален operational проблем.',
          'После използвай trend chart-а и recent snapshots таблицата, за да видиш дали проблемът е моментен spike или по-дълъг тренд.',
          'Top Mongo Peers и Top Local Mongo Clients са за connection debugging, когато ping или connections изглеждат abnormal.',
        ],
      },
      {
        title: 'Как да четеш proof-of-play health-а',
        points: [
          '`PoP Queue` показва колко aggregate/latest keys чакат flush.',
          '`PoP Flush` показва колко е траела последната flush операция и колко реда е обработила.',
          '`PoP Rollup` показва последния rollup snapshot за материализираните aggregate-и, не live now-playing payload-а.',
        ],
      },
    ],
    definitions: [
      {
        term: 'Current status',
        description: 'Общият health статус на последния snapshot: ok, warn или critical.',
      },
      {
        term: 'Live updates',
        description: 'Статусът на SSE връзката към health stream-а. Ако е disconnected, таблицата остава на последния зареден snapshot.',
      },
      {
        term: 'Load',
        description: '1-minute host load average. `Per CPU` нормализира същата стойност спрямо броя CPU ядра.',
      },
      {
        term: 'Memory Available',
        description: 'Най-полезният Linux headroom индикатор за свободна RAM под натиск.',
      },
      {
        term: 'Mongo Ping',
        description: 'Времето за ping към Mongo от последния snapshot. Висока стойност често значи storage, CPU или connection pressure.',
      },
      {
        term: 'Mongo Connections',
        description: 'Текущите client socket-и към mongod, плюс active/available/total created counters, ако са налични.',
      },
      {
        term: 'PoP Queue / Flush / Rollup',
        description: 'Operational indicators за proof-of-play telemetry pipeline: чакащи ключове, последен flush и последен rollup.',
      },
    ],
  },
  {
    routePrefix: '/pmi-runtime-controls',
    title: 'PMI Runtime Controls',
    description: 'Административна страница за runtime switches върху PMI ingestion, debug visibility и status telemetry behavior.',
    points: [
      'Тук се управляват safe runtime toggles без backend redeploy.',
      'Не всички cards са editable: част от тях са env-controlled и страницата ги показва само като read-only status.',
      'След save backend-ът връща и свеж Server Health snapshot, за да се види immediate operational effect.',
    ],
    sections: [
      {
        title: 'Как да ползваш страницата',
        points: [
          'Променяй само controls, за които разбираш operational effect-а, защото някои влияят на telemetry write volume и debugging visibility.',
          'След save прегледай success message-а и после сравни със `Server Health`, ако променяш ingestion или persistence поведение.',
          'Ако нямаш `page.pmi_runtime_controls.edit`, ще виждаш текущото състояние, но toggle-ите ще останат read-only.',
        ],
      },
      {
        title: 'Editable vs read-only controls',
        points: [
          '`Proof-of-play ingestion`, `Mongo persistence`, `Now-playing debug panel` и `Status raw logging` са editable runtime controls.',
          '`MQTT listener` и `SSE now-playing receivable` са status cards за env/runtime state и не се променят от тази първа версия.',
        ],
      },
    ],
    definitions: [
      {
        term: 'Source',
        description: 'Откъде идва текущата effective стойност: runtime config, env/default или друга backend source логика.',
      },
      {
        term: 'Status label',
        description: 'Човеко-четимата оценка на effective state-а на съответния control.',
      },
      {
        term: 'Proof-of-play ingestion',
        description: 'Главният switch за PMI proof-of-play ingestion behavior. Ако е изключен, persistence не може да остане включен.',
      },
      {
        term: 'Proof-of-play Mongo persistence',
        description: 'Определя дали proof-of-play трябва да пише latest/raw/aggregate данни в Mongo, вместо да остане live-only.',
      },
      {
        term: 'Now-playing debug panel',
        description: 'UI-only switch за debug панела в PMI Devices P. Не променя ingestion-а на събитията.',
      },
      {
        term: 'Status raw logging',
        description: 'Контролира дали raw status telemetry да се persist-ва. Това е по-високорисков write-path и трябва да се включва съзнателно.',
      },
      {
        term: 'Restart required',
        description: 'Индикатор, че конкретният control/state би изисквал process restart, за да се промени effective behavior-ът.',
      },
    ],
  },
]);
